import { render, staticRenderFns } from "./pointModal.vue?vue&type=template&id=a70ab6c8&scoped=true"
import script from "./pointModal.vue?vue&type=script&lang=js"
export * from "./pointModal.vue?vue&type=script&lang=js"
import style0 from "./pointModal.vue?vue&type=style&index=0&id=a70ab6c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ab6c8",
  null
  
)

export default component.exports